import React from 'react';
import { useCalendarActionsData } from '../../../../services/calendarActionsProvider';
import {
  registrationEvents,
  useRegistrationControllers,
} from '../../../../services/acceptanceRegistration';

const UpdateRegistrationFromCalendar = () => {
  const { notify } = useRegistrationControllers();

  const { interval, targetDate } = useCalendarActionsData();

  const handleClick = () => {
    notify(registrationEvents.UPDATE_REGISTRATION_FROM_CALENDAR, {
      interval,
      targetDate,
    });
  };

  return <div onClick={handleClick}>Редактировать запись</div>;
};

export default UpdateRegistrationFromCalendar;
